export default __webpack_public_path__ + "static/media/error.d67abca6.svg";